import axios from 'axios';
import config from 'config';
import { getAiAuthorizationClaims } from './aiChatAuthHelpers';

const {
  cognitiveLayer: {
    api: { dev: devUrl },
    endpoints: {
      aiWorkspace: { taskAdvance },
    },
  },
} = config;

export const advanceAiWorkspaceTask = async (taskId) => {
  if (!taskId) throw new Error('Task ID is required');

  const taskUrl = taskAdvance.replace('{taskId}', encodeURIComponent(taskId));
  const response = await axios.post(
    `${devUrl}${taskUrl}?apiKey=${process.env.REACT_APP_TP_API_KEY_DEV}`,
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization-Claims': getAiAuthorizationClaims(),
      },
    },
  );
  return response.data?.data;
};

export const streamAiWorkspaceTaskEvents = async ({ taskId, onEvent, signal }) => {
  if (!taskId) throw new Error('Task ID is required');

  const taskUrl = taskAdvance
    .replace('/advancements', '/events')
    .replace('{taskId}', encodeURIComponent(taskId));
  const response = await fetch(
    `${devUrl}${taskUrl}?apiKey=${process.env.REACT_APP_TP_API_KEY_DEV}`,
    {
      headers: {
        'Authorization-Claims': getAiAuthorizationClaims(),
      },
      signal,
    },
  );
  if (!response.ok) throw new Error(`Task event stream failed: ${response.status}`);

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';

  const processBuffer = () => {
    let boundary = buffer.indexOf('\n\n');
    while (boundary !== -1) {
      const frame = buffer.slice(0, boundary);
      buffer = buffer.slice(boundary + 2);
      const dataLine = frame.split('\n').find((line) => line.startsWith('data:'));
      if (dataLine) {
        try {
          onEvent(JSON.parse(dataLine.slice(5).trim()));
        } catch {
          // Ignore malformed SSE frames and wait for the next lifecycle event.
        }
      }
      boundary = buffer.indexOf('\n\n');
    }
  };

  try {
    let result = await reader.read();
    while (!result.done) {
      buffer += decoder.decode(result.value, { stream: true });
      processBuffer();
      // eslint-disable-next-line no-await-in-loop -- SSE frames are ordered.
      result = await reader.read();
    }
  } finally {
    reader.cancel();
  }
};
